import React, { useState, useEffect } from 'react'
import { Snackbar, Alert, IconButton, Button, Box } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import CloseIcon from '@mui/icons-material/Close'
import useCustomTranslate from 'src/hooks/useCustomTranslate'

export const ErrorHandler = ({ error, callback }) => {
  const { translate } = useCustomTranslate()
  const [showDetail, setShowDetail] = useState(false)
  const [showAlert, setShowAlert] = useState(true)

  const getStatus = () => {
    try {
      return error?.response?.status || error?.status_code
    } catch (error) {
      return null
    }
  }

  const isStatus418 = getStatus() === 418
  const isStatus207 = getStatus() === 207
  useEffect(() => {
    if (isStatus418 || isStatus207) {
      setShowAlert(true)
      setShowDetail(false)
    }
  }, [error, isStatus418, isStatus207])

  if (!isStatus418 && !isStatus207) {
    if (typeof callback === 'function') {
      callback()
    } else {
      return (
        <Snackbar
          open={showAlert}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          autoHideDuration={1000}
          onClose={() => setShowAlert(false)}
        >
          <Alert
            sx={{
              backgroundColor: '#c62828',
              width: '200px',
              color: 'white',
            }}
            icon={false}
            action={
              <IconButton
                aria-label='close'
                size='small'
                onClick={() => setShowAlert(false)}
                sx={{ color: 'white' }}
              >
                <CloseIcon fontSize='inherit' />
              </IconButton>
            }
          >
            Error
          </Alert>
        </Snackbar>
      )
    }
  }

  const message = error?.response?.data?.message || error?.message || 'Error'
  const errors = error?.response?.data?.data?.errors || error?.data?.errors || null

  let detailErrors = []
  if (errors && (Array.isArray(errors) || typeof errors === 'string')) {
    detailErrors = Array.isArray(errors) ? errors : [errors]
  }
  const getBackgroundColor = () => {
    if (isStatus207) {
      return '#FF9800'
    }
    if (isStatus418) {
      return '#c62828'
    }
    return '#c62828'
  }


  return (
    <Snackbar
      open={showAlert}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={15000}
      TransitionProps={{ onExited: () => setShowAlert(false) }}
    >
      <Alert
        sx={{
          backgroundColor: getBackgroundColor(),
          width: '500px',
          transition: 'height 0.3s ease-in-out',
        }}
        icon={false}
        action={
          <IconButton
            aria-label='close'
            size='small'
            onClick={() => setShowAlert(false)}
            sx={{ color: 'white' }}
          >
            <CloseIcon fontSize='inherit' />
          </IconButton>
        }
      >
        <Box
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          color={'white'}
          fontSize={'18px'}
          sx={{
            width: '430px',
          }}
        >
          {translate(message)}
        </Box>
        <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
          {detailErrors.length > 0 && (
            <Button
              onClick={() => setShowDetail(!showDetail)}
              endIcon={showDetail ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              sx={{ textTransform: 'none', paddingLeft: 6, marginTop: 1, fontSize: '11px', color: 'white' }}
            >
              {showDetail ? translate('ra.action.hidden') : translate('ra.saved_queries.see_details')}
            </Button>
          )}
        </Box>
        <Box
          sx={{
            maxHeight: showDetail ? 'auto' : '0px',
            overflow: 'hidden',
            transition: 'max-height 0.3s ease-in-out',
          }}
        >
          {showDetail && (
            <Box mt={2}>
              {detailErrors.map((err, index) => (
                <Box
                  key={index}
                  component='div'
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: 2,
                    marginBottom: 1,
                    color: 'white',
                  }}
                >
                  <span style={{ marginRight: '8px' }}>•</span>
                  <span>{err}</span>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Alert>
    </Snackbar>
  )
}
